module.exports = __webpack_public_path__ + "img/swap-page.918893f1.png";